import { render, staticRenderFns } from "./ComixLogo.vue?vue&type=template&id=d7608062&scoped=true&"
var script = {}
import style0 from "./ComixLogo.vue?vue&type=style&index=0&id=d7608062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7608062",
  null
  
)

export default component.exports